var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.1,242.22c-4.88,41.37-23.77,89.46-61.49,111.56-57,33.39-52.23,84.74-163.47,107.07a229,229,0,0,1-49.33,4.66,190.82,190.82,0,0,1-24.21-2c-70.7-10.32-118.28-59.47-135.74-118.8-23-78,22.9-129.1,53.3-159.87S141.83,58.19,251,35.38a222,222,0,0,1,50.7-4.82c38.85,1,81.22,13.71,110.54,40.34,2.2,2,4.34,4.08,6.43,6.21C459.45,118.94,476.76,185.83,470.1,242.22Z",
    style: {
      fill: "#3C59D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.1,242.22c-4.88,41.37-23.77,89.46-61.49,111.56-57,33.39-52.23,84.74-163.47,107.07a229,229,0,0,1-49.33,4.66,190.82,190.82,0,0,1-24.21-2c-70.7-10.32-118.28-59.47-135.74-118.8-23-78,22.9-129.1,53.3-159.87S141.83,58.19,251,35.38a222,222,0,0,1,50.7-4.82c38.85,1,81.22,13.71,110.54,40.34,2.2,2,4.34,4.08,6.43,6.21C459.45,118.94,476.76,185.83,470.1,242.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-69"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.11,206.24c-3.93,2.72-14.47,4.56-14.48,4.56s.9-7.32,1-7.77c1.35-5.28,7.07-14.67,13.15-15a7.21,7.21,0,0,1,7.43,7.75C170.06,200,166.45,203.92,163.11,206.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134,338.93c0,.25,0,.48,0,.72L130.43,342c0-1,0-2,0-3,0-2.93.05-6.06.14-9.28a78.6,78.6,0,0,1-8.93-2.23c-2.41,3.91-9.49,9.34-10.41,10,1.59,2.42,3.15,4.75,4.66,6.93q1.56,2.25,3,4.31l-4,.78c-.67-1-1.35-2-2-3.07-1.62-2.44-3.3-5.09-5-7.82-1.08.46-9.92,4.14-14.4,4-4.06-.11-9.21-1.38-11.71-4.89a7.21,7.21,0,0,1,2-10.55c5.29-3,15.21,1.71,19.23,5.38.24.22,2.55,2.86,4,4.54-.69-1.11-1.37-2.19-2.07-3.36-1.39-2.28-2.71-4.61-4.14-7.1-.65-1.23-1.3-2.48-2-3.73s-1.24-2.61-1.88-3.93c-1.41-3.09-2.69-6.28-3.9-9.53-2,1.21-9.19,5.42-13.25,5.93s-9.31,0-12.31-3.06a7.21,7.21,0,0,1,.35-10.73c4.78-3.79,15.3-.62,19.83,2.4.28.19,3.29,2.73,4.91,4.15-.71-2-1.44-3.91-2.1-5.91-1.9-5.79-3.65-11.7-5.42-17.6-.54-1.8-1.1-3.59-1.66-5.39-.71.44-9.14,5.62-13.68,6.19-4,.51-9.32,0-12.32-3.06a7.21,7.21,0,0,1,.36-10.73c4.77-3.79,15.3-.61,19.83,2.41.34.23,4.66,3.88,5.71,4.86-1.22-4-2.48-7.89-3.87-11.71a129,129,0,0,0-6.56-15.12c-.33.21-9.11,5.66-13.76,6.24-4,.51-9.32,0-12.32-3.06a7.21,7.21,0,0,1,.36-10.73c4.77-3.79,15.3-.61,19.83,2.41.35.24,5,4.17,5.79,4.94-.15-.28-.27-.59-.42-.87a92.08,92.08,0,0,0-9.21-13.71c-1.88-2.4-3.82-4.58-5.75-6.66-1.53,1.18-8.59,6.51-12.71,7.5-4,.94-9.26,1-12.58-1.69a7.21,7.21,0,0,1-.82-10.7c4.33-4.3,15.14-2.3,20,.21.26.14,2.78,1.82,4.6,3.07-.89-.93-1.78-1.9-2.65-2.77-3.25-3.28-6.42-6.07-9.25-8.53-1.62-1.38-3.11-2.6-4.52-3.73-2.11.38-10.62,1.79-14.67.78S16,211.46,14.34,207.5a7.22,7.22,0,0,1,4.2-9.88c5.82-1.81,14.49,4.94,17.63,9.4.27.38,3.81,6.88,3.7,6.9l-.12,0c1.38,1.05,2.84,2.2,4.41,3.49,2.89,2.4,6.14,5.13,9.46,8.35a126.81,126.81,0,0,1,10.25,10.89,93.4,93.4,0,0,1,9.62,13.68,1.51,1.51,0,0,1,.09.18c-.37-1.75-1.26-6.66-1.29-7-.35-5.43,2.15-16.14,7.81-18.38a7.21,7.21,0,0,1,9.48,5c1.17,4.15-1,9-3.5,12.2-2.76,3.66-11.5,8.4-12.2,8.78A128.65,128.65,0,0,1,81,266.6c1.2,3.08,2.31,6.23,3.39,9.4-.27-1.52-.51-2.88-.52-3.07-.36-5.44,2.14-16.14,7.81-18.39a7.21,7.21,0,0,1,9.47,5c1.18,4.14-1,9-3.49,12.2s-9.86,7.48-11.83,8.56c.4,1.22.82,2.43,1.21,3.66,1.9,5.86,3.77,11.71,5.79,17.4.7,2,1.47,4,2.24,5.91-.24-1.35-.44-2.49-.45-2.67-.36-5.43,2.14-16.14,7.81-18.38a7.22,7.22,0,0,1,9.48,5.05c1.17,4.13-1.05,8.95-3.5,12.19s-9.14,7.07-11.47,8.37c.84,2,1.68,4,2.59,5.83.64,1.27,1.18,2.53,1.9,3.77l2,3.68c1.39,2.3,2.8,4.67,4.21,6.87,1,1.54,1.92,3,2.87,4.45-.72-2-2.07-5.91-2.14-6.25a28,28,0,0,1,1-14.09,7.7,7.7,0,0,1-.21-1.59,7.21,7.21,0,0,1,7.47-7.71c6.08.4,11.75,9.82,13.07,15.1.08.31.55,3.79.81,6,0-1.32.07-2.6.13-3.95.1-2.67.29-5.34.47-8.21.13-1.39.27-2.78.41-4.19s.41-2.87.6-4.32c.53-3.35,1.23-6.72,2-10.1-2.35-.1-10.66-.55-14.32-2.37s-7.79-5.11-8.59-9.34,1.84-8.38,6.22-8.75c6.07-.53,13.1,7.92,15.21,12.94.13.32,1.24,4.09,1.81,6.17.48-2,1-4.06,1.51-6.09,1.6-5.88,3.41-11.78,5.18-17.67.55-1.8,1.07-3.61,1.6-5.41-.84,0-10.73-.36-14.83-2.39-3.65-1.8-7.79-5.11-8.59-9.34a7.21,7.21,0,0,1,6.22-8.75c6.07-.53,13.1,7.93,15.21,12.94.16.38,1.75,5.81,2.08,7.21,1.16-4,2.29-7.95,3.23-11.91a128.21,128.21,0,0,0,2.87-16.22c-.39,0-10.72-.31-14.92-2.39-3.64-1.81-7.78-5.12-8.58-9.34a7.22,7.22,0,0,1,6.21-8.76c6.08-.53,13.1,7.93,15.21,12.95.17.39,1.87,6.23,2.11,7.31,0-.31.1-.64.13-.95a93.61,93.61,0,0,0-.11-16.52c-.25-3-.67-5.92-1.13-8.72-1.93.14-10.75.69-14.74-.77-3.82-1.39-8.3-4.23-9.56-8.34s.91-8.53,5.22-9.38c6-1.19,13.89,6.44,16.54,11.19.14.26,1.32,3,2.14,5.1-.23-1.26-.44-2.57-.68-3.77-.9-4.52-2-8.61-3-12.22-.59-2-1.16-3.89-1.71-5.6-2-.85-9.85-4.37-12.66-7.44s-5.42-7.58-4.64-11.81a7.21,7.21,0,0,1,8.95-5.93c5.85,1.7,9.36,12.12,9.52,17.57,0,.47-.62,7.84-.72,7.8l-.12,0c.57,1.64,1.16,3.41,1.76,5.35,1.09,3.59,2.28,7.67,3.28,12.19a127,127,0,0,1,2.55,14.73,94.89,94.89,0,0,1,.47,16.72,1.36,1.36,0,0,0,0,.2c.65-1.66,2.62-6.25,2.81-6.59,2.7-4.73,10.69-12.28,16.66-11a7.23,7.23,0,0,1,5.12,9.44c-1.31,4.1-5.82,6.89-9.65,8.25-4.33,1.52-14.23.65-15,.58a127,127,0,0,1-2.58,16.84c-.7,3.24-1.51,6.48-2.36,9.72.61-1.42,1.17-2.69,1.26-2.86,2.7-4.72,10.69-12.27,16.66-11,4.3.9,6.39,5.42,5.12,9.44s-5.81,6.89-9.65,8.24-12.35.8-14.58.62c-.34,1.24-.67,2.48-1,3.72-1.65,5.93-3.32,11.85-4.78,17.71-.52,2.06-.95,4.11-1.39,6.16.54-1.26,1-2.32,1.1-2.47,2.7-4.73,10.69-12.28,16.65-11a7.21,7.21,0,0,1,5.12,9.44c-1.3,4.1-5.81,6.89-9.64,8.24s-11.53.86-14.19.65c-.38,2.12-.78,4.23-1.06,6.3-.15,1.41-.41,2.76-.49,4.19s-.21,2.81-.32,4.2c-.11,2.68-.24,5.44-.28,8,0,1.82,0,3.55-.06,5.3.49-2.06,1.53-6.07,1.66-6.4,1.94-5.08,8.7-13.75,14.79-13.42a7.22,7.22,0,0,1,6.49,8.55c-.67,4.25-4.7,7.69-8.29,9.61-3.94,2.11-13.47,2.78-14.67,2.85C134,333.47,134,336.28,134,338.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.37,229.49c-.08.07-3.28-6.6-3.43-7.05-1.78-5.14-2.2-16.13,2.68-19.79A7.21,7.21,0,0,1,67.09,205c2.22,3.69,1.35,8.92-.16,12.69C65.16,222.14,57.38,229.48,57.37,229.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M471.66,272.21c-2.87.56-9.23-1-9.24-1s2.3-3.88,2.48-4.11c2.05-2.62,7.56-6.49,11.07-5.2a4.42,4.42,0,0,1,2.26,6.17C477.08,270.44,474.1,271.73,471.66,272.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422.8,339.47l-.17.41-2.6.42c.24-.56.48-1.12.74-1.7.71-1.65,1.52-3.39,2.35-5.17a49.72,49.72,0,0,1-4.46-3.45c-2.31,1.61-7.61,2.92-8.3,3.08.3,1.74.61,3.43.92,5,.21,1.09.43,2.14.64,3.16l-2.42-.54c-.13-.72-.26-1.46-.4-2.22-.3-1.77-.6-3.67-.88-5.62-.72,0-6.58-.11-9.06-1.28-2.25-1.06-4.82-3-5.37-5.61a4.42,4.42,0,0,1,3.7-5.43c3.71-.4,8.11,4.69,9.47,7.74.08.17.72,2.22,1.11,3.52-.11-.8-.23-1.57-.33-2.39-.22-1.63-.39-3.26-.58-5-.06-.84-.13-1.7-.19-2.57s-.06-1.77-.09-2.66c0-2.08,0-4.18.15-6.3-1.42.19-6.48.78-8.88.07s-5.23-2.27-6.16-4.74a4.43,4.43,0,0,1,2.84-5.93c3.6-.95,8.73,3.41,10.52,6.22.12.17,1.18,2.33,1.74,3.53.08-1.27.15-2.55.27-3.83.36-3.71.83-7.46,1.28-11.2.14-1.14.26-2.28.39-3.43-.5.08-6.5.91-9.19.12-2.38-.71-5.23-2.27-6.15-4.74a4.41,4.41,0,0,1,2.83-5.93c3.61-.95,8.73,3.41,10.53,6.22.13.21,1.66,3.32,2,4.12.28-2.51.54-5,.7-7.51a77.28,77.28,0,0,0,0-10.09c-.24,0-6.5.94-9.24.12-2.39-.7-5.23-2.27-6.16-4.73a4.41,4.41,0,0,1,2.83-5.93c3.61-1,8.73,3.41,10.53,6.21.14.22,1.78,3.57,2,4.19,0-.19,0-.39,0-.59a56.7,56.7,0,0,0-1.79-9.94c-.47-1.81-1-3.51-1.59-5.15-1.15.29-6.42,1.55-9,1.09s-5.45-1.69-6.64-4a4.42,4.42,0,0,1,2.16-6.21c3.49-1.34,9.06,2.43,11.15,5,.11.14,1.11,1.7,1.83,2.85-.27-.74-.54-1.5-.81-2.2-1-2.63-2.11-5-3.09-7-.57-1.18-1.11-2.23-1.62-3.2-1.28-.31-6.4-1.61-8.42-3.16s-4.06-4-4-6.64a4.41,4.41,0,0,1,4.78-4.51c3.71.41,6.91,6.33,7.58,9.59.05.29.45,4.8.38,4.79l-.08,0c.52.93,1.06,1.93,1.62,3,1,2,2.18,4.38,3.26,7a79.69,79.69,0,0,1,3.07,8.62,57.25,57.25,0,0,1,2,10,.57.57,0,0,0,0,.13c.21-1.07.92-4.05,1-4.27,1.13-3.13,5.16-8.52,8.89-8.39a4.41,4.41,0,0,1,4.08,5.15c-.36,2.61-2.79,4.77-5,6-2.45,1.38-8.51,1.89-9,1.93a78.28,78.28,0,0,1,.2,10.42c-.08,2-.23,4.07-.4,6.11.22-.92.42-1.74.46-1.85,1.13-3.14,5.16-8.53,8.89-8.4a4.41,4.41,0,0,1,4.07,5.16c-.35,2.61-2.78,4.76-4.95,6s-7.36,1.78-8.73,1.9c-.07.78-.14,1.57-.22,2.35-.37,3.75-.76,7.49-1,11.18-.09,1.29-.14,2.58-.19,3.86.2-.82.37-1.51.4-1.61,1.14-3.13,5.16-8.52,8.89-8.39a4.42,4.42,0,0,1,4.08,5.16c-.36,2.6-2.79,4.76-5,6s-6.86,1.72-8.48,1.87c0,1.32,0,2.63,0,3.91.05.87,0,1.71.14,2.58s.17,1.72.25,2.56c.21,1.63.42,3.31.67,4.89.16,1.1.34,2.14.52,3.2.08-1.3.29-3.82.33-4a17.19,17.19,0,0,1,4-7.65,5.32,5.32,0,0,1,.28-.94,4.41,4.41,0,0,1,6.08-2.49c3.31,1.72,4.17,8.39,3.62,11.68,0,.19-.62,2.25-1,3.55.34-.73.67-1.44,1-2.18.71-1.47,1.47-2.93,2.27-4.49l1.27-2.25c.4-.76.93-1.51,1.39-2.27,1.12-1.75,2.34-3.47,3.6-5.17-1.29-.63-5.84-2.93-7.44-4.84s-3.11-4.78-2.53-7.35a4.42,4.42,0,0,1,5.64-3.38c3.53,1.19,5.4,7.66,5.35,11,0,.21-.31,2.59-.5,3.9.77-1,1.53-2,2.34-3,2.34-2.9,4.8-5.77,7.24-8.64.75-.87,1.48-1.76,2.22-2.64-.46-.22-5.92-2.83-7.72-5-1.6-1.9-3.11-4.77-2.53-7.34a4.42,4.42,0,0,1,5.64-3.38c3.53,1.19,5.4,7.66,5.35,11,0,.25-.45,3.68-.6,4.55,1.63-1.94,3.23-3.9,4.73-5.88a78,78,0,0,0,5.59-8.4c-.22-.1-5.93-2.8-7.78-5-1.6-1.9-3.11-4.77-2.52-7.34a4.41,4.41,0,0,1,5.63-3.38c3.54,1.19,5.4,7.66,5.36,11,0,.26-.48,3.95-.62,4.61.1-.17.22-.33.31-.5a56.52,56.52,0,0,0,4-9.29c.6-1.76,1.08-3.48,1.51-5.17-1.12-.39-6.2-2.25-8.08-4s-3.61-4.41-3.31-7a4.42,4.42,0,0,1,5.23-4c3.64.8,6.2,7,6.52,10.33,0,.18,0,2-.05,3.38.19-.76.39-1.54.55-2.28.6-2.75,1-5.31,1.31-7.58.17-1.3.3-2.47.41-3.57-.89-1-4.45-4.86-5.27-7.27s-1.18-5.58.29-7.76a4.42,4.42,0,0,1,6.48-1.13c2.86,2.39,2.27,9.09,1,12.18-.11.27-2.27,4.25-2.32,4.2l-.06-.05c-.08,1.05-.18,2.19-.32,3.43-.28,2.28-.6,4.85-1.15,7.63a79.65,79.65,0,0,1-2.19,8.89,58.09,58.09,0,0,1-3.84,9.49l-.06.11c.77-.78,3-2.87,3.19-3,2.68-2,9-4.26,12.05-2.09a4.41,4.41,0,0,1,.55,6.54c-1.74,2-4.95,2.44-7.43,2.26-2.8-.21-8.14-3.12-8.56-3.36a77.77,77.77,0,0,1-5.58,8.81c-1.19,1.65-2.44,3.26-3.71,4.87.69-.65,1.31-1.22,1.41-1.29,2.67-2,9-4.26,12-2.1a4.42,4.42,0,0,1,.56,6.55c-1.74,2-4.95,2.44-7.43,2.26s-7.12-2.58-8.33-3.23l-1.48,1.83c-2.38,2.93-4.77,5.83-7,8.76-.79,1-1.54,2.07-2.29,3.11.62-.57,1.14-1.05,1.23-1.11,2.67-2,9-4.26,12-2.1a4.41,4.41,0,0,1,.55,6.55c-1.73,2-4.95,2.44-7.43,2.25s-6.67-2.35-8.11-3.11c-.73,1.09-1.47,2.18-2.14,3.27-.43.75-.91,1.45-1.3,2.23l-1.21,2.27c-.72,1.48-1.47,3-2.14,4.45-.47,1-.89,2-1.33,3,.78-1,2.35-3,2.5-3.18,2.34-2.37,8.26-5.57,11.59-3.89a4.42,4.42,0,0,1,1.54,6.39c-1.42,2.22-4.53,3.15-7,3.35-2.73.22-8.23-1.75-8.92-2C424.1,336.38,423.42,338,422.8,339.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M406.67,259.3c-.06,0-.22-4.51-.2-4.8.27-3.32,2.73-9.58,6.36-10.44a4.41,4.41,0,0,1,5.29,3.9c.35,2.61-1.42,5.33-3.19,7.07C412.85,257.09,406.68,259.29,406.67,259.3Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-69"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.46,108.67V98.33l-10.33-1.15A24.51,24.51,0,0,0,112.6,91l6.52-8.15-7.31-7.32-8.12,6.5a24.47,24.47,0,0,0-6.14-2.57L96.4,69.1H86.05L84.91,79.43A24.89,24.89,0,0,0,78.75,82l-8.16-6.52-7.31,7.31,6.49,8.12A25.23,25.23,0,0,0,67.2,97L56.83,98.16v10.35l10.33,1.15a24.08,24.08,0,0,0,2.53,6.15L63.16,124l7.32,7.31,8.12-6.49a24.85,24.85,0,0,0,6.14,2.57l1.15,10.38H96.23l1.15-10.33a24.54,24.54,0,0,0,6.16-2.54l8.16,6.53,7.31-7.32-6.5-8.12a24.87,24.87,0,0,0,2.58-6.14Zm-34.32,7.09a12.35,12.35,0,1,1,12.35-12.34A12.35,12.35,0,0,1,91.14,115.76Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,87.91,165,81.06l-7,.39a16.6,16.6,0,0,0-2.36-3.8l3.41-6.12-5.65-4-4.66,5.2a16.74,16.74,0,0,0-4.35-1l-1.91-6.74-6.85,1.15.39,7a16.6,16.6,0,0,0-3.8,2.36L126.1,72l-4,5.65,5.2,4.66a16.74,16.74,0,0,0-1,4.35l-6.74,1.91,1.15,6.85,7-.39a16.6,16.6,0,0,0,2.36,3.8l-3.41,6.12,5.65,4,4.66-5.2a16.33,16.33,0,0,0,4.35,1l1.91,6.75,6.85-1.15-.39-7a16.22,16.22,0,0,0,3.8-2.35l6.12,3.41,4-5.65-5.2-4.66a16.74,16.74,0,0,0,1-4.35Zm-21.94,8.5A8.29,8.29,0,1,1,151,86.87,8.29,8.29,0,0,1,144.17,96.41Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.77,348.34,458.31,350,457,352.06l-79.27-42.7a23.1,23.1,0,0,0-5.26-1.89,50.51,50.51,0,0,0-6.89-1.14,66.69,66.69,0,0,0-7.67-.32,56.81,56.81,0,0,0-7.6.58l-31.47,4.6-1.11-.65-27.83,4.06,1.07.66L32.32,353.06a50.68,50.68,0,0,0-7.92,1.75c-.94.29-1.8.6-2.6.93l-6.06-5.23v10.24a2.77,2.77,0,0,0,.75,2.22l50.23,58.31a12.16,12.16,0,0,0,4.86,3.08,35.55,35.55,0,0,0,7.72,1.91,61.16,61.16,0,0,0,9.5.56A66.44,66.44,0,0,0,99,425.89l200.15-34.28-.15-.12,159.42-27.3a18.71,18.71,0,0,0,4.87-1.9,5.25,5.25,0,0,0,2.3-2.37,2.55,2.55,0,0,0,.16-.94h0Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.83,373.46l-11.6,1.8a2,2,0,0,0-1.73,2v.13a2,2,0,0,0,2.38,2.07l11.61-1.93a2,2,0,0,0,1.7-2.07h0A2,2,0,0,0,361.83,373.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,366.35l-11.6,1.81a2,2,0,0,0-1.73,2v.12a2,2,0,0,0,2.38,2.07l11.6-1.94a2,2,0,0,0,1.71-2.07h0A2,2,0,0,0,401.48,366.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.85,363.64l-11.63,1.61a2.07,2.07,0,0,0-1.77,1.94v.13a2,2,0,0,0,2.34,2.11l11.64-1.75a2,2,0,0,0,1.74-2h0A2,2,0,0,0,419.85,363.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "440.88 354.6 342.31 298.91 41.84 342.99 44.06 342.66 108.61 411.27 440.88 354.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.27,304a1.18,1.18,0,0,0-.25-.1l-.31,0h-.37l-.41,0-1,.14-.36.08a.54.54,0,0,0-.21.08.09.09,0,0,0,0,.1s0,.08.12.12a1.06,1.06,0,0,0,.25.09l.32.05h.37l.41-.05.95-.14.37-.07.21-.09s.06-.06,0-.1,0-.07-.13-.11M441,345.66l4.39-.73,3.89,2.14-4.4.74L441,345.66m11.05,2.43-6.58-3.62-5.78,1,6.54,3.63,5.82-1m-90.7-45.55.88-.13.38.21-.88.13-.38-.21m72.87,40.52a.36.36,0,0,1-.18-.16.15.15,0,0,1,0-.16.69.69,0,0,1,.2-.14,2.14,2.14,0,0,1,.37-.1l.47,0a3.91,3.91,0,0,1,.49,0,3,3,0,0,1,.45.08,1.86,1.86,0,0,1,.34.13.36.36,0,0,1,.18.16.15.15,0,0,1,0,.16.69.69,0,0,1-.2.14,1.43,1.43,0,0,1-.37.09,3.56,3.56,0,0,1-.47.05,3.91,3.91,0,0,1-.49,0,3,3,0,0,1-.45-.08,1.34,1.34,0,0,1-.34-.13m.49-1,0,0,0,0s0,0,0,0l0,0a.19.19,0,0,1,.09,0l.15,0h.39l.27.05a5,5,0,0,1,.58.12,6.38,6.38,0,0,1,.73.21,4.46,4.46,0,0,1,.74.32,2.2,2.2,0,0,1,.32.21,1.94,1.94,0,0,1,.26.23,1.41,1.41,0,0,1,.18.27.84.84,0,0,1,.08.31.07.07,0,0,1,0,.06.28.28,0,0,1-.11.05.38.38,0,0,1-.16,0h-.33l-.12,0-.11,0-.08,0-.08-.09a.59.59,0,0,0-.07-.26.62.62,0,0,0-.15-.22,1.34,1.34,0,0,0-.21-.2l-.26-.17a3.93,3.93,0,0,0-.56-.24,5.7,5.7,0,0,0-.56-.17l-.43-.09-.2,0-.08,0-.08,0-.07,0-.05,0M364.8,302l.89-.13.38.21-.89.13-.38-.21m60.11,35.77,4.76-.78,1.18.65-4.77.79-1.17-.66m10.7,3.71,0,0,0,0s0,0,0,0l0,0a.19.19,0,0,1,.09-.05l.15,0h.38l.33.05c.19,0,.46.09.77.17a9.94,9.94,0,0,1,1,.29,6.56,6.56,0,0,1,1,.44,4.5,4.5,0,0,1,.43.27,2.83,2.83,0,0,1,.36.32,1.67,1.67,0,0,1,.24.37,1.13,1.13,0,0,1,.11.41s0,0,0,.06a.23.23,0,0,1-.11.05.33.33,0,0,1-.15,0h-.34l-.12,0a.29.29,0,0,1-.1,0l-.09,0-.08-.09a1.06,1.06,0,0,0-.09-.36,1.46,1.46,0,0,0-.22-.33,2.68,2.68,0,0,0-.3-.28l-.38-.24a6.12,6.12,0,0,0-.83-.36c-.29-.1-.57-.18-.82-.24l-.62-.13-.26-.05h-.09l-.08,0-.06,0-.06,0m-9.13-2.84,5.72-.94,1.19.66-5.73.94-1.18-.66m1.58.88,6.4-1.05,1.2.65-6.42,1.06-1.18-.66m-63.11-37,3.63-.47,1.41.77-.64.1-1.05-.58-2,.26.32,0,.29,0,.24.06.21.09q.17.11.18.18c0,.06,0,.11-.09.16a1.28,1.28,0,0,1-.36.14,5.51,5.51,0,0,1-.58.11l-1.25.19a5.88,5.88,0,0,1-.71.07,4.8,4.8,0,0,1-.66,0,2.52,2.52,0,0,1-.57-.09,2,2,0,0,1-.47-.17.52.52,0,0,1-.24-.22.15.15,0,0,1,.08-.18,1,1,0,0,1,.36-.16,4.87,4.87,0,0,1,.61-.13l.43-.06.37.21L364,303a2.08,2.08,0,0,0-.36.07.68.68,0,0,0-.22.08.1.1,0,0,0-.05.1s.05.07.12.11a1.45,1.45,0,0,0,.25.1l.31,0h.37l.41,0,1.24-.19a2.56,2.56,0,0,0,.36-.07.71.71,0,0,0,.21-.08s.06-.07.05-.1a.31.31,0,0,0-.13-.12.84.84,0,0,0-.19-.07l-.24,0h-.3a2.24,2.24,0,0,0-.35,0l-.14,0-.38-.21m-3.23-2.8.52-.08a5.88,5.88,0,0,1,.71-.07c.22,0,.44,0,.65,0a4.85,4.85,0,0,1,.57.09,1.76,1.76,0,0,1,.47.18.51.51,0,0,1,.24.21.15.15,0,0,1-.08.18,1,1,0,0,1-.35.16,3.87,3.87,0,0,1-.61.12,8.58,8.58,0,0,1-1.42.08c-.47,0-.93,0-1.38-.08s-.87-.08-1.29-.1a6.27,6.27,0,0,0-1.16,0l-.1,0,1.15.63-.64.1-1.54-.85.54-.08a8.23,8.23,0,0,1,1.46-.09c.46,0,.91.05,1.35.09s.86.08,1.3.09a6.46,6.46,0,0,0,1.31-.06,2.55,2.55,0,0,0,.4-.08.74.74,0,0,0,.24-.08c.05,0,.07-.07.06-.1s-.05-.07-.13-.12l-.25-.09-.31,0h-.37l-.41.05-.56.08-.37-.2m2.18,1,.29,0a5.72,5.72,0,0,1,.7-.07c.23,0,.44,0,.65,0a4.37,4.37,0,0,1,.56.09,2.56,2.56,0,0,1,.47.18q.21.12.24.21a.15.15,0,0,1-.06.19,1.25,1.25,0,0,1-.36.15,4.87,4.87,0,0,1-.61.13l-.16,0a3.91,3.91,0,0,1-.48.05,3.57,3.57,0,0,1-.46,0l-.42,0a2.32,2.32,0,0,1-.38-.07.12.12,0,0,1,0,.14.34.34,0,0,1-.16.11,1.5,1.5,0,0,1-.3.1,3.51,3.51,0,0,1-.42.08l-.49.07c-.25,0-.48.06-.71.08a4.63,4.63,0,0,1-.65,0,3.36,3.36,0,0,1-.58-.09,1.58,1.58,0,0,1-.46-.18q-.21-.11-.24-.21c0-.07,0-.13.08-.19a1.28,1.28,0,0,1,.36-.15,4.87,4.87,0,0,1,.61-.13l.43-.06.37.2-.48.07-.36.08a.71.71,0,0,0-.21.08c-.05,0-.06.06-.05.1a.26.26,0,0,0,.12.11.81.81,0,0,0,.25.09,1.44,1.44,0,0,0,.31.05h.39a4,4,0,0,0,.44-.05l.49-.07.38-.07a.72.72,0,0,0,.21-.09.11.11,0,0,0,0-.11.38.38,0,0,0-.13-.11l-.21-.12.63-.1.24.13a.85.85,0,0,0,.24.09l.3.05h.35l.4,0,.29-.05.4-.07a1,1,0,0,0,.24-.09s.06-.06.05-.1a.26.26,0,0,0-.12-.11,1.06,1.06,0,0,0-.25-.09,1.53,1.53,0,0,0-.32-.05H365l-.41.05-.32.05-.37-.21m.93,3.74a.55.55,0,0,1-.25-.21.15.15,0,0,1,.07-.19A.87.87,0,0,1,365,304a3.36,3.36,0,0,1,.61-.13l3.25-.49a6.21,6.21,0,0,1,.73-.07h.66a3.33,3.33,0,0,1,.58.1,1.71,1.71,0,0,1,.48.18.56.56,0,0,1,.25.22.14.14,0,0,1-.06.18,1,1,0,0,1-.36.16,4.5,4.5,0,0,1-.61.13h-.11l-.38-.2.17,0a2.15,2.15,0,0,0,.35-.07.54.54,0,0,0,.21-.08.1.1,0,0,0,.05-.1.29.29,0,0,0-.14-.12,1.45,1.45,0,0,0-.25-.1l-.33,0h-.4l-.48.06-1.42.21h.38a3.31,3.31,0,0,1,.34,0l.3.07a1.33,1.33,0,0,1,.24.11c.11.06.18.12.19.18s0,.11-.1.16a1.12,1.12,0,0,1-.35.13,3.67,3.67,0,0,1-.58.12l-1,.15c-.24,0-.48.06-.71.07s-.45,0-.66,0a4.71,4.71,0,0,1-.58-.09,1.84,1.84,0,0,1-.47-.19m72,36.44-.05,0,0,0a0,0,0,0,1,0,0l0,0,.1-.05.15,0h.38l.4.07c.24,0,.57.11.95.2a12.71,12.71,0,0,1,1.24.36,8.72,8.72,0,0,1,1.25.54c.19.11.37.22.54.34a3.38,3.38,0,0,1,.44.4,1.86,1.86,0,0,1,.3.45,1.5,1.5,0,0,1,.15.51.07.07,0,0,1,0,.06.23.23,0,0,1-.1.05l-.16,0H442l-.12,0-.1,0a.2.2,0,0,1-.08,0l-.09-.08a1.41,1.41,0,0,0-.12-.47,1.86,1.86,0,0,0-.28-.41,2.69,2.69,0,0,0-.39-.36,3.88,3.88,0,0,0-.48-.3,8,8,0,0,0-1-.46c-.36-.12-.71-.22-1-.3s-.6-.13-.81-.17l-.38-.06-.08,0-.08,0-.07,0,0,0m1.84,4.37,7.08-1.18,7.4,4.07-2.71.46.68.37-1.68.29-.68-.38-2.72.46-7.37-4.09m-9-4.9,7.6-1.26,1.2.66-7.61,1.26-1.19-.66m22.27,3.43-16.43-9-11.68-.54c-.88,0-1.74-.11-2.56-.22s-1.6-.24-2.33-.4a17.65,17.65,0,0,1-2-.56,10.1,10.1,0,0,1-1.6-.69L383,314.57a3.73,3.73,0,0,1-1-.71,1.4,1.4,0,0,1-.37-.74,1.06,1.06,0,0,1,.22-.74,2.66,2.66,0,0,1,.8-.68l4.84-2.9-14-7.63a23,23,0,0,0-5.27-1.91,49.21,49.21,0,0,0-6.91-1.16,69.55,69.55,0,0,0-7.7-.33,59.41,59.41,0,0,0-7.65.59l-3.71.55,98.57,55.69,4.08-.69a28.84,28.84,0,0,0,6.59-1.83,8.07,8.07,0,0,0,3.47-2.52,2.63,2.63,0,0,0,.17-2.85,7.75,7.75,0,0,0-3.28-2.86",
    style: {
      fill: "#3C59D6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,299.87a1.76,1.76,0,0,0-.47-.18,4.85,4.85,0,0,0-.57-.09c-.21,0-.43,0-.65,0a5.88,5.88,0,0,0-.71.07l-.52.08.37.2.56-.08.41-.05h.37l.31,0,.25.09c.08.05.12.08.13.12s0,.07-.06.1a.74.74,0,0,1-.24.08,2.55,2.55,0,0,1-.4.08,6.46,6.46,0,0,1-1.31.06c-.44,0-.86-.05-1.3-.09s-.89-.08-1.35-.09a8.23,8.23,0,0,0-1.46.09l-.54.08,1.54.85.64-.1-1.15-.63.1,0a6.27,6.27,0,0,1,1.16,0c.42,0,.85.06,1.29.1s.91.07,1.38.08a8.58,8.58,0,0,0,1.42-.08,3.87,3.87,0,0,0,.61-.12,1,1,0,0,0,.35-.16.15.15,0,0,0,.08-.18.51.51,0,0,0-.24-.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.57,300.93a2.56,2.56,0,0,0-.47-.18,4.37,4.37,0,0,0-.56-.09c-.21,0-.42,0-.65,0a5.72,5.72,0,0,0-.7.07l-.29,0,.37.21.32-.05.41-.05h.36a1.53,1.53,0,0,1,.32.05,1.06,1.06,0,0,1,.25.09.26.26,0,0,1,.12.11s0,.07-.05.1a1,1,0,0,1-.24.09l-.4.07-.29.05-.4,0h-.35l-.3-.05a.85.85,0,0,1-.24-.09l-.24-.13-.63.1.21.12a.38.38,0,0,1,.13.11.11.11,0,0,1,0,.11.72.72,0,0,1-.21.09l-.38.07-.49.07a4,4,0,0,1-.44.05h-.39a1.44,1.44,0,0,1-.31-.05.81.81,0,0,1-.25-.09.26.26,0,0,1-.12-.11s0-.07.05-.1a.71.71,0,0,1,.21-.08l.36-.08.48-.07-.37-.2-.43.06a4.87,4.87,0,0,0-.61.13,1.28,1.28,0,0,0-.36.15c-.08.06-.11.12-.08.19s.1.14.24.21a1.58,1.58,0,0,0,.46.18,3.36,3.36,0,0,0,.58.09,4.63,4.63,0,0,0,.65,0c.23,0,.46,0,.71-.08L363,302a3.51,3.51,0,0,0,.42-.08,1.5,1.5,0,0,0,.3-.1.34.34,0,0,0,.16-.11.12.12,0,0,0,0-.14,2.32,2.32,0,0,0,.38.07l.42,0a3.57,3.57,0,0,0,.46,0,3.91,3.91,0,0,0,.48-.05l.16,0a4.87,4.87,0,0,0,.61-.13,1.25,1.25,0,0,0,.36-.15.15.15,0,0,0,.06-.19q0-.09-.24-.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,302.62l-.38-.21-.88.13.38.21.88-.13m3.46-.52-.38-.21-.89.13.38.21.89-.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,302.85l-1.41-.77-3.63.47.38.21.14,0a2.24,2.24,0,0,1,.35,0h.3l.24,0a.84.84,0,0,1,.19.07.31.31,0,0,1,.13.12s0,.06-.05.1a.71.71,0,0,1-.21.08,2.56,2.56,0,0,1-.36.07l-1.24.19-.41,0H364l-.31,0a1.45,1.45,0,0,1-.25-.1c-.07,0-.11-.07-.12-.11a.1.1,0,0,1,.05-.1.68.68,0,0,1,.22-.08A2.08,2.08,0,0,1,364,303l.47-.07-.37-.21-.43.06a4.87,4.87,0,0,0-.61.13,1,1,0,0,0-.36.16.15.15,0,0,0-.08.18.52.52,0,0,0,.24.22,2,2,0,0,0,.47.17,2.52,2.52,0,0,0,.57.09,4.8,4.8,0,0,0,.66,0,5.88,5.88,0,0,0,.71-.07l1.25-.19a5.51,5.51,0,0,0,.58-.11,1.28,1.28,0,0,0,.36-.14c.07-.05.11-.1.09-.16s-.07-.11-.18-.18l-.21-.09-.24-.06-.29,0-.32,0,2-.26,1.05.58.64-.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.47,304.42q-.11-.06-.12-.12a.09.09,0,0,1,0-.1.54.54,0,0,1,.21-.08L366,304l1-.14.41,0h.37l.31,0a1.18,1.18,0,0,1,.25.1c.08,0,.12.08.13.11s0,.07,0,.1l-.21.09-.37.07-.95.14-.41.05H366l-.32-.05a1.06,1.06,0,0,1-.25-.09m5.85-.88a1.71,1.71,0,0,0-.48-.18,3.33,3.33,0,0,0-.58-.1h-.66a6.21,6.21,0,0,0-.73.07l-3.25.49a3.36,3.36,0,0,0-.61.13.87.87,0,0,0-.36.16.15.15,0,0,0-.07.19.55.55,0,0,0,.25.21,1.84,1.84,0,0,0,.47.19,4.71,4.71,0,0,0,.58.09c.21,0,.43,0,.66,0s.47,0,.71-.07l1-.15a3.67,3.67,0,0,0,.58-.12,1.12,1.12,0,0,0,.35-.13c.08-.05.12-.11.1-.16s-.08-.12-.19-.18a1.33,1.33,0,0,0-.24-.11l-.3-.07a3.31,3.31,0,0,0-.34,0h-.38l1.42-.21.48-.06h.4l.33,0a1.45,1.45,0,0,1,.25.1.29.29,0,0,1,.14.12.1.1,0,0,1-.05.1.54.54,0,0,1-.21.08,2.15,2.15,0,0,1-.35.07l-.17,0,.38.2h.11a4.5,4.5,0,0,0,.61-.13,1,1,0,0,0,.36-.16.14.14,0,0,0,.06-.18.56.56,0,0,0-.25-.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "430.85 337.66 429.67 337.01 424.91 337.79 426.08 338.45 430.85 337.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "433.39 338.38 432.2 337.73 426.48 338.67 427.66 339.32 433.39 338.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "435.66 339.14 434.46 338.49 428.06 339.54 429.24 340.2 435.66 339.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "438.44 339.82 437.24 339.16 429.64 340.42 430.83 341.08 438.44 339.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.69,345.44l5.78-1,6.58,3.62-5.82,1-6.54-3.63m13.42,2.77-7.4-4.07-7.08,1.18,7.37,4.09,2.72-.46-.26-.14,1.68-.29.26.15,2.71-.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "449.28 347.07 445.39 344.93 441 345.66 444.88 347.81 449.28 347.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "451.08 349.04 450.4 348.67 450.14 348.52 448.46 348.81 448.72 348.95 449.4 349.33 451.08 349.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.61,342.51a4.46,4.46,0,0,0-.74-.32,6.38,6.38,0,0,0-.73-.21,5,5,0,0,0-.58-.12l-.27-.05h-.39l-.15,0a.19.19,0,0,0-.09,0l0,0s0,0,0,0l0,0,0,0,.05,0,.07,0,.08,0,.08,0,.2,0,.43.09a5.7,5.7,0,0,1,.56.17,3.93,3.93,0,0,1,.56.24l.26.17a1.34,1.34,0,0,1,.21.2.62.62,0,0,1,.15.22.59.59,0,0,1,.07.26l.08.09.08,0,.11,0,.12,0h.33a.38.38,0,0,0,.16,0,.28.28,0,0,0,.11-.05.07.07,0,0,0,0-.06.84.84,0,0,0-.08-.31,1.41,1.41,0,0,0-.18-.27,1.94,1.94,0,0,0-.26-.23,2.2,2.2,0,0,0-.32-.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.3,342.22a6.56,6.56,0,0,0-1-.44,9.94,9.94,0,0,0-1-.29c-.31-.08-.58-.13-.77-.17l-.33-.05h-.38l-.15,0a.19.19,0,0,0-.09.05l0,0s0,0,0,0l0,0,0,0,.06,0,.06,0,.08,0h.09l.26.05.62.13c.25.06.53.14.82.24a6.12,6.12,0,0,1,.83.36l.38.24a2.68,2.68,0,0,1,.3.28,1.46,1.46,0,0,1,.22.33,1.06,1.06,0,0,1,.09.36l.08.09.09,0a.29.29,0,0,0,.1,0l.12,0h.34a.33.33,0,0,0,.15,0,.23.23,0,0,0,.11-.05s0,0,0-.06a1.13,1.13,0,0,0-.11-.41,1.67,1.67,0,0,0-.24-.37,2.83,2.83,0,0,0-.36-.32,4.5,4.5,0,0,0-.43-.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.2,341.89a8.72,8.72,0,0,0-1.25-.54,12.71,12.71,0,0,0-1.24-.36c-.38-.09-.71-.16-.95-.2l-.4-.07H437l-.15,0-.1.05,0,0a0,0,0,0,0,0,0l0,0,.05,0,0,0,.07,0,.08,0,.08,0,.38.06c.21,0,.49.09.81.17s.67.18,1,.3a8,8,0,0,1,1,.46,3.88,3.88,0,0,1,.48.3,2.69,2.69,0,0,1,.39.36,1.86,1.86,0,0,1,.28.41,1.41,1.41,0,0,1,.12.47l.09.08a.2.2,0,0,0,.08,0l.1,0,.12,0h.34l.16,0a.23.23,0,0,0,.1-.05.07.07,0,0,0,0-.06,1.5,1.5,0,0,0-.15-.51,1.86,1.86,0,0,0-.3-.45,3.38,3.38,0,0,0-.44-.4c-.17-.12-.35-.23-.54-.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.37,342.7a1.86,1.86,0,0,0-.34-.13,3,3,0,0,0-.45-.08,3.91,3.91,0,0,0-.49,0l-.47,0a2.14,2.14,0,0,0-.37.1.69.69,0,0,0-.2.14.15.15,0,0,0,0,.16.36.36,0,0,0,.18.16,1.34,1.34,0,0,0,.34.13,3,3,0,0,0,.45.08,3.91,3.91,0,0,0,.49,0,3.56,3.56,0,0,0,.47-.05,1.43,1.43,0,0,0,.37-.09.69.69,0,0,0,.2-.14.15.15,0,0,0,0-.16.36.36,0,0,0-.18-.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.48,334.9l16.43,9a7.75,7.75,0,0,1,3.28,2.86,2.63,2.63,0,0,1-.17,2.85,8.07,8.07,0,0,1-3.47,2.52,28.84,28.84,0,0,1-6.59,1.83L108.61,411.27l-6,1a58.12,58.12,0,0,1-8.67.8,52.36,52.36,0,0,1-8.1-.48A31.34,31.34,0,0,1,79.27,411a10.73,10.73,0,0,1-4.19-2.61L74,407.15l-47.8-54.24-.86-1a2.3,2.3,0,0,1-.53-2.49A5.71,5.71,0,0,1,27.2,347a21,21,0,0,1,4.8-2.1,45.73,45.73,0,0,1,6.79-1.5l3.05-.45,300.47-44.07,3.71-.55a59.41,59.41,0,0,1,7.65-.59,69.55,69.55,0,0,1,7.7.33,49.21,49.21,0,0,1,6.91,1.16,23,23,0,0,1,5.27,1.91l14,7.63-4.84,2.9a2.66,2.66,0,0,0-.8.68,1.06,1.06,0,0,0-.22.74,1.4,1.4,0,0,0,.37.74,3.73,3.73,0,0,0,1,.71l32.25,17.92a10.1,10.1,0,0,0,1.6.69,17.65,17.65,0,0,0,2,.56c.73.16,1.51.3,2.33.4s1.68.18,2.56.22l11.68.54M462,344.28l-84.32-45.42a23.1,23.1,0,0,0-5.26-1.89,50.51,50.51,0,0,0-6.89-1.14,69,69,0,0,0-7.67-.33,58.49,58.49,0,0,0-7.6.59l-31.47,4.6-1.11-.66-27.83,4.06,1.07.67L32.32,342.56a51.91,51.91,0,0,0-7.92,1.74,25.2,25.2,0,0,0-5.64,2.44,6.74,6.74,0,0,0-2.82,2.82,2.65,2.65,0,0,0,.55,2.91l50.23,58.31a12.27,12.27,0,0,0,4.86,3.08,35.58,35.58,0,0,0,7.72,1.9,59.91,59.91,0,0,0,9.5.57A67.73,67.73,0,0,0,99,415.39l200.15-34.28L299,381l159.42-27.3a19.08,19.08,0,0,0,4.87-1.9,5.25,5.25,0,0,0,2.3-2.37,2.69,2.69,0,0,0-.37-2.58,8.73,8.73,0,0,0-3.16-2.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.61,411.27,44.06,342.66l-2.22.32-3.05.45a45.73,45.73,0,0,0-6.79,1.5,21,21,0,0,0-4.8,2.1,5.71,5.71,0,0,0-2.38,2.42,2.3,2.3,0,0,0,.53,2.49l.86,1L74,407.15l1.07,1.22A10.73,10.73,0,0,0,79.27,411a31.34,31.34,0,0,0,6.61,1.62,52.36,52.36,0,0,0,8.1.48,58.12,58.12,0,0,0,8.67-.8l6-1",
    style: {
      fill: "#3C59D6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.34,111s8.59,5.72,9.06,13.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.88,114.34s4.77,3.82,5.25,8.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.44,104.32s-8.58,8.11-10.49,14.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91,107.66s-4.77,6.2-4.77,10.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.2,
    y1: 189.7,
    x2: 285.05,
    y2: 206.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.73,
    y1: 198.76,
    x2: 286,
    y2: 214.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.23,
    y1: 176.82,
    x2: 188.71,
    y2: 190.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.41,
    y1: 182.54,
    x2: 184.89,
    y2: 193.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,122.34s-.44,9.27,1.2,13.91a42.73,42.73,0,0,1,1.95,10.32l-4.49,12.57s-4.19,1.35-4,2.69.15,2.55.15,2.55a1.1,1.1,0,0,0-.75,1.19c.15.9.45,2.1.45,2.1s-2.84,3.14-2.54,4.19,3.44,4.49,3.44,4.49,1.19-1,7.33.15,7.63,2.84,7.63,2.84,4,.15,4.49-2.69a8.59,8.59,0,0,0-.15-4c0-.6,1-1.8,1.19-3.89s-.3-3.89-.15-5.39,1.2-8.23,1.2-8.23-13-29.92-13-30.37S199.89,121.29,198.24,122.34Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.05 135.71 213.95 163.33 215.15 155.1 203.05 135.71",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.08,161.52s8.19,1,11.91,5.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,169.71s6.45-3.47,15.38.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.4,198.79s-13.62,25.92-19.48,48.11-4.82,34.13-4.82,36,3.56,45.64,3.56,45.64-1.67,4-.21,6.7a53,53,0,0,1,2.31,4.82s-9.42,9.42-12.15,11.31-6.49,5.23-2.72,8.58,12.77,1,15.91-.21,8.59-6.49,8.59-6.49,6.49-2.93,8.37-5.23,1.26-4.82,1.26-5.87a47.38,47.38,0,0,1,1.47-5.86l-.42-5.86c-.21-2.93,1-23.24,1.46-25.34S220.47,272,220.47,272s9.63-27,10.67-28.48,7.12-9.21,7.12-9.21,5,7.75,5.66,10.89,4.39,33.92,5.44,37.27,19.47,48.37,20.73,50a38.71,38.71,0,0,1,2.51,4s-1.46,4.82-.21,6.07a5.15,5.15,0,0,1,1.47,2.51s-6.07,13.62-6.07,16.34,1,4,7.53,4,10.06-5.45,11.1-9.43,4.61-10.68,5-12.56,1-1.26-.42-5.23-1.89-5.66-1.68-6.71a4.9,4.9,0,0,0-.42-2.51c-.2-.84-13.19-54.65-13.19-54.65l-1-21.56s1.88-39.16,1.46-44.39a33.84,33.84,0,0,0-.87-6.53s-34.56,2.12-46-.39S214.4,198.79,214.4,198.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,191.31s-1.5,6.43-1,7.48,9.28,7.18,25.74,9.27,30.22-1.34,33.81-3,3.59-6.28,3.59-6.28-28.58,6.88-42.49,1.79S215.45,191.31,215.45,191.31Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.65,91.44s-2.73-13.17,8-22.16,21-6.67,24.14-4.91,11.44,5.5,13.59,11.95,1.18,15.05,2.16,17.4,3.52,2.15,3.71,3.33l.2,1.17S280,109.36,283.9,116.79s-2.94,64.92-3.33,73.14.78,9.77-5.28,11.92-29.13,5.09-46-.39-15.84-11.73-15.45-14.27,6.46-15.84,6.07-17.6-4.31-13.49-4.31-13.49-14.27-22.88-16.42-28.94,0-6.06,1.76-8.8,17-21.12,17-21.12l-3.91-6.65Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.53,186.71a66.56,66.56,0,0,0,7.34,1.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.66,172.19A136.89,136.89,0,0,0,251,185.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13,178.15a115.08,115.08,0,0,0,11.17,6.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.25,121.06s9.93-7,12.16-17.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.05,125.78a23.05,23.05,0,0,0-.25,9.68c1,5.46.75,11.42,1,13.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.31 130.74 234.57 140.17 239.29 140.17 236.31 130.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,90.46s-7.23-1.56-6.26,1,7.24,4.24,7.24,4.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,90.46s1.57,9.32,3.53,14,4.88,9.38,8.79,12.51,6.65,7.82,9.59,7.63,7-3.91,8.21-6.26,3.91-12.71,3.91-12.71,1.37-1.37-10.17-10.56A25.91,25.91,0,0,0,212.91,90.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.77,95.09a25.91,25.91,0,0,0-23.86-4.63s1.57,9.32,3.53,14c.06.16.14.32.21.49,1.95-1.93,5.25-4.27,9.46-3.53,6.77,1.17,12.54,1.78,20.56,5.22l.27-1S248.31,104.28,236.77,95.09Z",
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,103.07c.32,1,0,2-.65,2.2s-1.49-.4-1.82-1.39,0-2,.64-2.2S221.89,102.08,222.22,103.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,101.42c.33,1,0,2-.64,2.2s-1.5-.4-1.83-1.39,0-2,.65-2.2S233.59,100.42,233.91,101.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,100.17s3-3.9,5.91-4.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,99.46a5.39,5.39,0,0,1,6.14.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.43,104.87s1,9.2,2.41,9.4,5.09-3.13,5.09-3.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.24,116.68A8.54,8.54,0,0,0,237.8,109",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,90.46s1.57,9.32,3.53,14,4.88,9.38,8.79,12.51,6.65,7.82,9.59,7.63,7-3.91,8.21-6.26,3.91-12.71,3.91-12.71,1.37-1.37-10.17-10.56A25.91,25.91,0,0,0,212.91,90.46Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,176.35l.3,24.08,10-.89,4.64-20.2S201.69,172.46,193.61,176.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.66,
    y1: 225.38,
    x2: 195.92,
    y2: 225.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.55,216.42l.07-2.32h-3.76c-1.83-.12-3.45,4.73-3.62,10.83s1.19,11.16,3,11.29H218l0-2.06a24.9,24.9,0,0,0,1.59-8.78A25.79,25.79,0,0,0,218.55,216.42Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,225.38c-.17,6.11-1.79,11-3.62,10.84s-3.19-5.18-3-11.29,1.79-11,3.63-10.83S221.8,219.27,221.64,225.38Z",
    style: {
      fill: "#828282",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,199.09l-.15,14.21s2.69,5.39,2.54,8.08,0,10.47-1.35,11.22a4.45,4.45,0,0,1-3.14.15l-1.49-.75s-5.09.75-7.78.15-5.84-2.24-6.29-4.79.75-8.82.75-8.82-6.13-15.41-4.79-17.51S198.1,194.9,209.47,199.09Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.07,328.51,218,361.21a1.78,1.78,0,0,0,1.67,1.89h0a1.77,1.77,0,0,0,1.89-1.66l2.11-33.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.12,412.71c-25.68,6.75-82.29,3.83-98.75-8-2.8-2-4.24-4.16-4.29-6.37-.08-3.53,1.29-6.65,4.21-9.53a30.71,30.71,0,0,1,8.47-5.64,161.05,161.05,0,0,0,20.09,8.36c15.83,5.39,29.62,7.43,41,6.06s18-5.8,17.75-11.85c-.34-7.83-12-14.13-27.12-14.65a157.72,157.72,0,0,0-34.8,2.72,86.73,86.73,0,0,0-16.95,5.06c-28.45-11.52-63.52-44.52-70.16-53.62-7.51-10.3-30.51-37.9-48.09-54.79a4.43,4.43,0,0,0-1.23-4.56,113.87,113.87,0,0,0-8.92-7.55c-3-2.23-6.11-4.5-9.24-6.74a4.43,4.43,0,0,0-4.69-.28q-2-1.42-4-2.83a4.44,4.44,0,0,0-1.88-4.31c-7.85-5.36-13-8.59-13.16-8.72a4.45,4.45,0,1,0-4.75,7.53s5.19,3.28,12.89,8.54a4.42,4.42,0,0,0,4.66.22c1.35.93,2.68,1.86,4,2.8a4.45,4.45,0,0,0,1.79,4.3c3.08,2.2,6.14,4.43,9.09,6.63a104.08,104.08,0,0,1,8.21,6.95,4.37,4.37,0,0,0,4.55.89c17.41,16.73,40.17,44.05,47.62,54.26,6.77,9.28,39.79,40.62,68.68,53.59a30.9,30.9,0,0,0-6.54,4.81,16.57,16.57,0,0,0-5.39,12.45c.08,3.51,2.08,6.7,5.93,9.48,11.82,8.53,39.52,12.32,64.6,12.32,14.76,0,28.62-1.32,37.8-3.74M449.33,375c6.8.23,13,1.69,17.4,4.12,3.6,2,5.81,4.5,5.9,6.74.16,3.64-5.44,6.69-14.26,7.75-20.95,2.52-46.66-8.29-55.71-12.52C415.89,376.3,434.21,374.47,449.33,375Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.05,
    y1: 381.13,
    x2: 397.76,
    y2: 383.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.72,
    y1: 378.82,
    x2: 402.66,
    y2: 381.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,312.05l-1,16.08a3.81,3.81,0,0,0,2.52,3.83,12.88,12.88,0,0,0,4.89.78,23.79,23.79,0,0,0,2.52-.27,3.81,3.81,0,0,0,3.2-3.54l.95-15.55Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.1,213.31l-7.54,95.06a6.11,6.11,0,0,0,5.47,6.55l7.61.77a6.1,6.1,0,0,0,6.69-5.64L239,214.42Z",
    style: {
      fill: "#3C59D6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.08,304.87l-.13,1.79s-.2,4.35-3.37,5.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.29,
    y1: 233.44,
    x2: 230.35,
    y2: 301.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.63 219.3 238.59 220.43 239.01 214.42 220.1 213.31 219.63 219.3",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.03,
    y: 250.5,
    width: 22.58,
    height: 9.49,
    transform: "translate(15.55 -12.99) rotate(3.4)",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,216.42l.06-2.32h-3.75c-1.84-.12-3.46,4.73-3.63,10.83s1.19,11.16,3,11.29h3.76l.05-2.06a24.9,24.9,0,0,0,1.59-8.78A25.82,25.82,0,0,0,244.8,216.42Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88,225.38c-.17,6.11-1.79,11-3.62,10.84s-3.19-5.18-3-11.29,1.78-11,3.62-10.83S248.05,219.27,247.88,225.38Z",
    style: {
      fill: "#828282",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.42,
    y1: 225.38,
    x2: 268.16,
    y2: 225.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,134.19,272.16,167s-2.37.17-2.17,1.36.64,2.62.64,2.62-1.9.42-1.93,1.6A39.38,39.38,0,0,0,270,178.3a22.18,22.18,0,0,1,9.44.72,54.74,54.74,0,0,1,6.08,2.53L288,182.8l1.07-4.46s3.53.57,3.61-2.5a19.93,19.93,0,0,0-1-6.18s1.85,1.47,1-3.51-1.88-9.51-1.88-9.51,2-29.26-1.4-35.73-11.78-10.24-11.78-10.24",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.28,167.48s7-3,13.65.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.93,159S281,157.3,274,164.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,178.3l-5.68,28.35,11.85,4.81L288,182.8S280.48,176,270,178.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.15,221.86l6.12-10.32s-5-4.47-8.83-5.77-10.58-1.48-10.58-1.48l-3,10.54s-10.64,6-10.82,7,.54,7.8,1.41,8.72,8.47,2.33,10.85,2.84,5.85-.29,6.18-1.48-1.56-3.18-1.55-3.63,4.8-.32,6.33-1.78A43.7,43.7,0,0,0,273.15,221.86Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.35,358.43A3.33,3.33,0,1,1,231,355.1,3.33,3.33,0,0,1,234.35,358.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.87,338.67a2.35,2.35,0,1,1-2.34-2.35A2.34,2.34,0,0,1,237.87,338.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.52,
    cy: 183.27,
    r: 36.55,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.28,
    cy: 182.59,
    r: 36.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.24,151.56a31.05,31.05,0,1,0,31,31.05A31.08,31.08,0,0,0,357.24,151.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.73,182.45v-.21c4.68-1,7.23-3.16,7.23-7.64,0-5.09-3.28-8-9.5-8.88v-7h-3.95v6.74h-3.66V158.7h-4v6.73h-8.8v5.19h1.73a1.79,1.79,0,0,1,1.48,1.53v22.17a1.79,1.79,0,0,1-1.48,1.53H343.1v5.25h8.8v6.67h4V201.1h3.66v6.68h3.95v-7c6.7-.94,10.72-4.27,10.72-10.06C374.18,185.91,371.18,183.26,365.73,182.45Zm-9.94-12.31h2.74c4.06,0,5.49,1.59,5.49,4.83s-1.48,4.94-5.49,4.94h-2.74Zm3.07,26.45h-3.07V185.45h3.07c4.61,0,6,1.76,6,5.38S363.47,196.59,358.86,196.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 94.94,
    r: 36.55,
    transform: "translate(39.07 284.18) rotate(-45)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.34,
    cy: 94.25,
    r: 36.55,
    transform: "translate(-10.33 57.78) rotate(-9.04)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.29,63.22a31.05,31.05,0,1,0,31,31.05A31.08,31.08,0,0,0,360.29,63.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,94.11V93.9c4.69-1,7.24-3.15,7.24-7.64,0-5.09-3.28-8-9.5-8.88v-7h-3.95V77.1H358.9V70.36H355v6.73h-8.8v5.2h1.73a1.78,1.78,0,0,1,1.48,1.52V106a1.79,1.79,0,0,1-1.48,1.53h-1.73v5.25H355v6.67h3.94v-6.67h3.67v6.68h3.95v-7c6.7-.94,10.72-4.27,10.72-10.06C377.24,97.57,374.24,94.92,368.78,94.11ZM358.84,81.8h2.75c4.06,0,5.49,1.59,5.49,4.83s-1.49,4.94-5.49,4.94h-2.75Zm3.08,26.46h-3.08V97.11h3.08c4.61,0,6,1.76,6,5.38S366.53,108.26,361.92,108.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.72,
    cy: 150.61,
    r: 36.55,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.48,
    cy: 149.92,
    r: 36.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.44,118.89a31.05,31.05,0,1,0,31.05,31.05A31.09,31.09,0,0,0,448.44,118.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.93,149.78v-.2c4.69-1,7.24-3.16,7.24-7.65,0-5.08-3.28-8-9.5-8.87v-7h-3.95v6.73h-3.67V126H443.1v6.72h-8.79V138H436a1.79,1.79,0,0,1,1.48,1.53v22.17a1.78,1.78,0,0,1-1.48,1.52h-1.73v5.25h8.79v6.68h3.95v-6.68h3.67v6.68h3.95v-7c6.69-1,10.72-4.27,10.72-10.06C465.39,153.25,462.38,150.6,456.93,149.78ZM447,137.48h2.75c4.06,0,5.48,1.59,5.48,4.83s-1.48,4.93-5.48,4.93H447Zm3.08,26.45H447V152.79h3.08c4.61,0,6,1.75,6,5.38S454.68,163.93,450.07,163.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.82,
    cy: 253.56,
    r: 29.95,
    transform: "translate(-36.52 452.02) rotate(-67.06)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.98,
    cy: 253,
    r: 29.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,227.58A25.44,25.44,0,1,0,346.38,253,25.47,25.47,0,0,0,321,227.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.9,252.88v-.16c3.84-.8,5.93-2.59,5.93-6.27,0-4.16-2.69-6.54-7.78-7.27v-5.75h-3.24V239h-3v-5.51h-3.24v5.51h-7.21v4.26h1.42a1.45,1.45,0,0,1,1.21,1.25v18.16a1.45,1.45,0,0,1-1.21,1.25h-1.42v4.31h7.21v5.46h3.24v-5.46h3v5.47h3.24v-5.7c5.48-.77,8.78-3.5,8.78-8.24C334.83,255.72,332.37,253.55,327.9,252.88Zm-8.14-10.08H322c3.32,0,4.49,1.31,4.49,4s-1.21,4.05-4.49,4.05h-2.25Zm2.52,21.67h-2.52v-9.12h2.52c3.77,0,4.94,1.44,4.94,4.4S326.05,264.47,322.28,264.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.55,
    cy: 308.09,
    r: 26.01,
    transform: "translate(-65.93 516.79) rotate(-67.12)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.96,
    cy: 307.6,
    r: 26.01,
    transform: "translate(-60.61 88.7) rotate(-13.13)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.93,285.52A22.09,22.09,0,1,0,377,307.61,22.12,22.12,0,0,0,354.93,285.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,307.5v-.15c3.34-.69,5.15-2.24,5.15-5.44,0-3.62-2.34-5.68-6.76-6.31v-5h-2.81v4.8h-2.61V290.6h-2.81v4.79h-6.26v3.7h1.24a1.27,1.27,0,0,1,1.05,1.08V316a1.27,1.27,0,0,1-1.05,1.08h-1.24v3.74h6.26v4.75h2.81v-4.75h2.61v4.76h2.81v-5c4.76-.67,7.63-3,7.63-7.15C367,310,364.85,308.08,361,307.5Zm-7.07-8.76h2c2.89,0,3.91,1.14,3.91,3.44s-1.06,3.51-3.91,3.51h-2Zm2.19,18.82H353.9v-7.92h2.19c3.28,0,4.29,1.25,4.29,3.82S359.37,317.56,356.09,317.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.45,
    cy: 331.34,
    r: 20.42,
    transform: "translate(-67.68 76.23) rotate(-13.17)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.2,
    cy: 330.96,
    r: 20.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.17,313.62A17.35,17.35,0,1,0,312.52,331,17.38,17.38,0,0,0,295.17,313.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,330.88v-.11c2.62-.54,4-1.77,4-4.27,0-2.85-1.83-4.47-5.31-5v-3.93h-2.2v3.77H294.4v-3.76h-2.21v3.76h-4.92v2.91h1a1,1,0,0,1,.83.85v12.39a1,1,0,0,1-.83.85h-1v2.93h4.92V345h2.21V341.3h2.05V345h2.2v-3.89c3.74-.52,6-2.38,6-5.62C304.64,332.82,303,331.34,299.92,330.88ZM294.36,324h1.54c2.27,0,3.06.89,3.06,2.69s-.82,2.76-3.06,2.76h-1.54Zm1.72,14.78h-1.72v-6.23h1.72c2.58,0,3.37,1,3.37,3S298.66,338.79,296.08,338.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.75,
    cy: 309.73,
    r: 14.87,
    transform: "translate(-64.63 67.99) rotate(-13.37)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.84,
    cy: 309.45,
    r: 14.87,
    transform: "translate(-127.79 426.87) rotate(-67.28)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,296.83a12.63,12.63,0,1,0,12.62,12.63A12.64,12.64,0,0,0,256.83,296.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,309.39v-.08c1.9-.4,2.94-1.29,2.94-3.11,0-2.07-1.33-3.25-3.86-3.61v-2.86h-1.61v2.74h-1.49v-2.74h-1.61v2.74h-3.57v2.11h.7a.73.73,0,0,1,.6.62v9a.72.72,0,0,1-.6.62h-.7V317h3.57v2.71h1.61V317h1.49v2.72h1.61v-2.83c2.72-.38,4.36-1.74,4.36-4.09C263.72,310.8,262.5,309.72,260.28,309.39Zm-4-5h1.11c1.65,0,2.23.64,2.23,2s-.6,2-2.23,2h-1.11Zm1.25,10.75h-1.25v-4.53h1.25c1.87,0,2.45.72,2.45,2.19S259.36,315.14,257.49,315.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.49,
    cy: 242.16,
    r: 14.87,
    transform: "translate(-44.89 96.23) rotate(-13.2)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.58,
    cy: 241.88,
    r: 14.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.56,229.26a12.63,12.63,0,1,0,12.63,12.63A12.65,12.65,0,0,0,392.56,229.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,241.82v-.08c1.9-.39,2.94-1.28,2.94-3.11,0-2.07-1.34-3.25-3.87-3.61v-2.85h-1.6v2.74H392v-2.73h-1.61v2.73h-3.58V237h.71a.72.72,0,0,1,.6.62v9a.73.73,0,0,1-.6.63h-.71v2.13h3.58v2.71H392v-2.71h1.49v2.71h1.6v-2.83c2.73-.38,4.37-1.73,4.37-4.09C399.46,243.23,398.23,242.16,396,241.82Zm-4-5h1.12c1.65,0,2.23.65,2.23,2s-.6,2-2.23,2H392Zm1.25,10.76H392v-4.53h1.25c1.88,0,2.46.71,2.46,2.18S395.1,247.58,393.22,247.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.73,
    cy: 349.46,
    r: 9.92,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.12,
    cy: 349.27,
    r: 9.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.11,340.85a8.43,8.43,0,1,0,8.42,8.43A8.44,8.44,0,0,0,253.11,340.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,349.23v-.05c1.27-.27,2-.86,2-2.08,0-1.38-.89-2.16-2.57-2.4v-1.91h-1.07v1.83h-1v-1.82h-1.07v1.82h-2.39V346h.47a.47.47,0,0,1,.4.41v6a.48.48,0,0,1-.4.42h-.47v1.42h2.39v1.81h1.07v-1.81h1v1.81h1.07v-1.88c1.81-.26,2.91-1.16,2.91-2.73C257.71,350.17,256.89,349.45,255.41,349.23Zm-2.7-3.34h.75c1.1,0,1.49.44,1.49,1.31s-.4,1.34-1.49,1.34h-.75Zm.84,7.18h-.84v-3h.84c1.25,0,1.64.47,1.64,1.46S254.8,353.07,253.55,353.07Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.363c983d5c6d39de01cc9389146f9164.svg";
export { ForwardRef as ReactComponent };